export const NATIVE_WEBVIEW_INJECTION_NAME = "ReactNativeWebView";
export const IS_NATIVE_WEBVIEW = "ReactNativeWebView" in window;
export const NATIVE_WEBVIEW = IS_NATIVE_WEBVIEW? window[NATIVE_WEBVIEW_INJECTION_NAME]: null;



// WEBPACK FOOTER //
// ./src/constants/native.js